module.exports = __webpack_public_path__ + "static/media/COS_TOOLS_3.5889295f.jpg";